var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DefaultPanel",
    {
      class: _vm.minimize ? "service-panel minimize" : "service-panel",
      attrs: {
        minimize: _vm.minimize,
        title: "Attività selezionata",
        "is-selected": _vm.selected
      }
    },
    [
      [
        _c("div", { staticClass: "row no-gutters" }, [
          _c(
            "div",
            { class: _vm.minimize ? "col-12" : "col-12 col-md-4" },
            [
              _c("small-carousel", {
                attrs: { images: _vm.images, autoplay: false }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: _vm.minimize ? "col-12 minimize" : "col-12 col-md-8 right"
            },
            [
              _c("div", { staticClass: "position-relative" }, [
                _c("div", { staticClass: "border-bottom pb-1 mb-1" }, [
                  _c(
                    "h6",
                    { staticClass: "text-primary text-uppercase mb-0" },
                    [_vm._v(_vm._s(_vm.valueC.categoria))]
                  ),
                  _vm._v(" "),
                  _c(
                    "h4",
                    {
                      staticClass: "mb-0",
                      staticStyle: { height: "25px", overflow: "hidden" }
                    },
                    [_vm._v(_vm._s(_vm.valueC.nome))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "border-bottom pb-1 mb-2" }, [
                  _vm.valueC.ore
                    ? _c("div", [
                        _c("img", {
                          attrs: {
                            src: require("../../../assets/images/svg/black/icone_durata.svg"),
                            height: "12px"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.valueC.ore))])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.valueC.tipologia
                    ? _c("div", [
                        _vm.valueC.telefono
                          ? _c("div", { staticClass: "phone" }, [
                              _c("img", {
                                attrs: {
                                  src: require("../../../assets/images/svg/black/icone_phone.svg"),
                                  height: "12px"
                                }
                              }),
                              _vm._v(" "),
                              _c("b", [_vm._v(_vm._s(_vm.valueC.tipologia))])
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.valueC.descrizione
                    ? _c(
                        "div",
                        {
                          staticClass: "d-flex",
                          style: _vm.isTrasferimento
                            ? "height: 80px; overflow: hidden"
                            : "height: 40px; overflow: hidden"
                        },
                        [
                          _c("img", {
                            staticClass: "mt-1 mr-1",
                            attrs: {
                              src: require("../../../assets/images/svg/black/icone_lingua.svg"),
                              height: "12px"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "mt-1 d-block font-italic",
                              staticStyle: { "line-height": "12px" }
                            },
                            [_vm._v(_vm._s(_vm.valueC.descrizione))]
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                !_vm.isTrasferimento
                  ? _c(
                      "div",
                      {
                        class: _vm.minimize
                          ? "position-relative text-center"
                          : "position-relative d-flex justify-content-between"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-md-flex justify-content-between mb-1 pr-1"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "pt-1" },
                              _vm._l(_vm.groupsSelected, function(item, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "pb-2" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "pretty p-default p-curve d-block"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: item.selected,
                                              expression: "item.selected"
                                            }
                                          ],
                                          staticClass: "pt-1",
                                          attrs: {
                                            type: "checkbox",
                                            name: "camera" + index
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              item.selected
                                            )
                                              ? _vm._i(item.selected, null) > -1
                                              : item.selected
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.onCameraSelected(item)
                                            },
                                            change: function($event) {
                                              var $$a = item.selected,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      item,
                                                      "selected",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      item,
                                                      "selected",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(item, "selected", $$c)
                                              }
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-block state p-secondary-o text-uppercase",
                                            staticStyle: {
                                              "font-size": "0.7rem"
                                            }
                                          },
                                          [
                                            _c("label", [
                                              _vm._v(
                                                _vm._s("Camera " + (index + 1))
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            !_vm.isMobile
                              ? _c("DateSelect", {
                                  attrs: {
                                    dates: _vm.value.dates,
                                    value: _vm.dateSelected
                                  },
                                  on: {
                                    input: function(date) {
                                      _vm.dateSelected = date
                                      _vm.modified = true
                                      _vm.trackTabAttivitaCambiaData()
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "d-md-flex justify-content-end",
                            staticStyle: { height: "30px" }
                          },
                          [
                            _c("div", { staticClass: "d-md-flex" }, [
                              _vm.prezzoCamere
                                ? _c("div", { staticClass: "text-right" }, [
                                    _c(
                                      "h5",
                                      {
                                        staticClass: "nowrap currency mb-0",
                                        staticStyle: { "line-height": "20px" }
                                      },
                                      [
                                        _vm._v(
                                          "+ " +
                                            _vm._s(
                                              _vm.formatMoney(_vm.prezzoCamere)
                                            ) +
                                            " €"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          "line-height": "10px",
                                          "font-size": "0.6rem"
                                        }
                                      },
                                      [_vm._v("per le camere selezionate")]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isMobile
                                ? _c("div", [
                                    _vm.selected && !_vm.modified
                                      ? _c(
                                          "h6",
                                          {
                                            staticClass:
                                              "py-2 px-1 text-primary"
                                          },
                                          [_vm._v("SELEZIONATO")]
                                        )
                                      : _c(
                                          "button",
                                          {
                                            staticClass:
                                              "px-2 py-1 btn btn-primary ml-2",
                                            attrs: {
                                              disabled: _vm.disabledAdd
                                            },
                                            on: { click: _vm.onAdd }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.selected
                                                    ? "modifica"
                                                    : "aggiungi"
                                                ) +
                                                "\n                                    "
                                            )
                                          ]
                                        )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            !_vm.isMobile
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "icon-circle-border-blue ml-1"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "javascript:void(0)" },
                                        on: { click: _vm.onDetail }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: require("../../../assets/images/svg/blue/icone_dettagli.svg"),
                                            width: "16px"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isMobile &&
                            _vm.selected &&
                            !_vm.value.isObbligatorio
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "icon-circle-border-blue ml-1"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "javascript:void(0)" },
                                        on: { click: _vm.onRemove }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: require("../../../assets/images/svg/blue/icone_cestino.svg"),
                                            width: "16px"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  : _c("div", [
                      _c(
                        "div",
                        {
                          class: _vm.minimize
                            ? ""
                            : "d-flex justify-content-end"
                        },
                        [
                          !_vm.value.isTrasferimentoFisso
                            ? _c(
                                "div",
                                {
                                  class: _vm.minimize
                                    ? ""
                                    : "d-flex justify-content-end"
                                },
                                [
                                  _vm.showAggiungiAndata
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "px-2 py-1 btn btn-primary mx-1 nowrap",
                                          on: { click: _vm.onAggiungiAndata }
                                        },
                                        [_vm._v("+ andata")]
                                      )
                                    : _c(
                                        "button",
                                        {
                                          staticClass:
                                            "px-2 py-1 btn btn-secondary mx-1",
                                          attrs: {
                                            disabled:
                                              _vm.value.isTrasferimentoFisso
                                          },
                                          on: { click: _vm.onRemoveAndata }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("../../../assets/images/svg/white/icone_cestino.svg"),
                                              width: "16px"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                                    andata\n                                "
                                          )
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _vm.showAggiungiRitorno
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "px-2 py-1 btn btn-primary mx-1 nowrap",
                                          on: { click: _vm.onAggiungiRitorno }
                                        },
                                        [_vm._v("+ ritorno")]
                                      )
                                    : _c(
                                        "button",
                                        {
                                          staticClass:
                                            "px-2 py-1 btn btn-secondary mx-1",
                                          attrs: {
                                            disabled:
                                              _vm.value.isTrasferimentoFisso
                                          },
                                          on: { click: _vm.onRemoveRitorno }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("../../../assets/images/svg/white/icone_cestino.svg"),
                                              width: "16px"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                                    ritorno\n                                "
                                          )
                                        ]
                                      )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "icon-circle-border-blue ml-1",
                              staticStyle: { height: "30px" }
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: "javascript:void(0)" },
                                  on: { click: _vm.onDetail }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/images/svg/blue/icone_dettagli.svg"),
                                      width: "16px"
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                _vm._v(" "),
                _vm.isMobile && !_vm.isTrasferimento
                  ? _c(
                      "div",
                      { staticClass: "justify-content-between mt-2" },
                      [
                        _c("DateSelect", {
                          staticClass: "mb-2",
                          attrs: {
                            dates: _vm.value.dates,
                            value: _vm.dateSelected
                          },
                          on: {
                            input: function(date) {
                              _vm.dateSelected = date
                              _vm.modified = true
                              _vm.trackTabAttivitaCambiaData()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-between" },
                          [
                            _vm.selected && !_vm.modified
                              ? _c(
                                  "h5",
                                  {
                                    staticClass: "py-2 px-1 text-primary",
                                    staticStyle: { "line-height": "6px" }
                                  },
                                  [_vm._v("SELEZIONATO")]
                                )
                              : _c(
                                  "button",
                                  {
                                    staticClass:
                                      "w-100 px-2 py-1 btn btn-primary",
                                    attrs: { disabled: _vm.disabledAdd },
                                    on: { click: _vm.onAdd }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.selected ? "modifica" : "aggiungi"
                                        ) +
                                        "\n                            "
                                    )
                                  ]
                                ),
                            _vm._v(" "),
                            _c("div", { staticClass: "d-flex" }, [
                              _c(
                                "div",
                                { staticClass: "icon-circle-border-blue ml-1" },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "javascript:void(0)" },
                                      on: { click: _vm.onDetail }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../../assets/images/svg/blue/icone_dettagli.svg"),
                                          width: "16px",
                                          height: "16px"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.selected && !_vm.value.isObbligatorio
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "icon-circle-border-blue ml-1"
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "javascript:void(0)" },
                                          on: { click: _vm.onRemove }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("../../../assets/images/svg/blue/icone_cestino.svg"),
                                              width: "16px"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]
          )
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49b44239", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49b44239","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/ServicePanel.vue
// module id = null
// module chunks = 